$(function() {

    $('.login-block').css({
        'position' : 'absolute',
        'left' : '50%',
        'top' : '45%',
        'margin-left' : -$('.login-block').actual('outerWidth')/2,
        'margin-top' : -$('.login-block').actual('outerHeight')/2
    });
    $('.login-rights').css({
        'position' : 'absolute',
        'left' : '50%',
        'margin-left' : -$('.login-rights').actual('outerWidth')/2
    });
    $('.login-wrapper').fadeIn('normal');

    $('input[name="submit-login"]').on('click', function() {
        var action = $('form#login-form').attr('action');
        var formData = $('form#login-form').serialize();

        ajax_post(action, formData, function(response) {
            if (response.status === 'success') {
                window.location.href = response.url;
            } else {
                message(response.status, response.message);
            }
        });
    });

    $('input[name="submit-reset"]').on('click', function(){
        var resetForm = $('form#reset-form');
        var action = resetForm.attr('action');
        var formData = resetForm.serialize();

        ajax_post(action, formData, function(response){
            if(response.status === 'success') {
                $('#reset-form-content').html(response.html);
            } else {
                message(response.status, response.message);
            }
        });
    });

    $('input[name="submit-reset-password"]').on('click', function(){
        var resetForm = $('form#reset-password-form');
        var action = resetForm.attr('action');
        var formData = resetForm.serialize();

        ajax_post(action, formData, function(response){
            if(response.status === 'success') {
                window.location.href = response.url;
            } else {
                message(response.status, response.message);
            }
        });
    });

    $('.password-reset').click(show_reset);
    $('.to-login-form').click(show_login);

});

function show_login() {
    $('#reset-form').fadeOut(700, function(){
        $('#email').val($('#reset_email').val());
        $('#login-form').fadeIn();
    });
}

function show_reset() {
    $('#login-form').fadeOut(700, function(){
        $('#reset_email').val($('#email').val());
        $('#reset-form').fadeIn();
    });
}


// WEBPACK FOOTER //
// ./Modules/Users/Resources/assets/js/login.js